import { Alert, Snackbar } from '@mui/material';
import { useEffect, useState } from 'react';

export default function ApiErrorNotice() {
  const [message, setMessage] = useState<string | null>(null);
  useEffect(() => {
    const onProblem = (event: Event) => setMessage((event as CustomEvent<string | null>).detail);
    window.addEventListener('gretna-api-problem', onProblem);
    return () => window.removeEventListener('gretna-api-problem', onProblem);
  }, []);
  return (
    <Snackbar open={!!message} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert severity="error" onClose={() => setMessage(null)} sx={{ maxWidth: 600 }}>
        {message}
      </Alert>
    </Snackbar>
  );
}
